<mat-icon
  *ngIf="internal"
  matTooltip="Internal candidate"
  data-cy="association-label-internal-candidate"
>assignment_ind</mat-icon>

<div
  [ngClass]="associationLabel.label | lowercase"
  *ngIf="associationLabel$ | async as associationLabel"
  class="mat-caption"
  data-cy="association-label"
>
  <span>{{ associationLabel.text }}</span>
</div>
